(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-pills"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('collection-pill-carousel')) {
  customElements.define('collection-pill-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cp-track');
      this.previous = this.querySelector('.cp-prev');
      this.next = this.querySelector('.cp-next');
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.previous.addEventListener('click',()=>this.move(-1),options);
      this.next.addEventListener('click',()=>this.move(1),options);
      this.track.addEventListener('scroll',()=>this.update(),options);
      this.observer = new ResizeObserver(()=>this.update());
      this.observer.observe(this.track);
      this.track.querySelectorAll('.cp-pill').forEach(pill=>this.observer.observe(pill));
      document.addEventListener('shopify:block:select',event=>{
        if(this.contains(event.target)) event.target.scrollIntoView({block:'nearest',inline:'nearest',behavior:'auto'});
      },options);
      this.update();
    }
    update() {
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.previous.hidden = this.next.hidden = !overflow;
      const position = Math.abs(this.track.scrollLeft);
      this.previous.disabled = position < 2;
      this.next.disabled = position >= this.track.scrollWidth - this.track.clientWidth - 2;
    }
    move(direction) {
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      this.track.scrollBy({left:direction*(rtl?-1:1)*this.track.clientWidth*.7,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    disconnectedCallback() {this.controller?.abort();this.observer?.disconnect();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('premium-product-menu')) {
    customElements.define('premium-product-menu', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.trigger = this.closest('.section-header').querySelector('.pm-launch');
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.trigger.addEventListener('click', event => this.open(event.detail === 0), options);
        this.dialog.addEventListener('keydown', () => this.dialog.removeAttribute('data-pointer-open'), options);
        this.querySelector('.pm-close').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.restore(), options);
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), options);
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next !== undefined) {
              event.preventDefault();
              this.select(next);
              this.tabs[next].focus();
            }
          }, options);
        });
        document.addEventListener('shopify:block:select', event => {
          const index = this.tabs.findIndex(tab => tab.getAttribute('aria-controls') === 'PMPanel-' + event.detail.blockId);
          if (index >= 0) { this.open(); this.select(index); }
        }, options);
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(this)) this.restore(false);
        }, options);
      }
      open(keyboard = true) {
        if (this.dialog.open) return;
        this.dialog.toggleAttribute('data-pointer-open', !keyboard);
        this.previousOverflow = document.body.style.overflow;
        this.locked = true;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        this.trigger.setAttribute('aria-expanded', 'true');
        this.querySelector('.pm-close').focus();
      }
      restore(focus = true) {
        if (!this.locked) return;
        document.body.style.overflow = this.previousOverflow;
        this.locked = false;
        this.trigger.setAttribute('aria-expanded', 'false');
        if (focus && this.trigger.isConnected) this.trigger.focus();
      }
      select(index) {
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.querySelector('#' + tab.getAttribute('aria-controls')).hidden = i !== index;
        });
        this.querySelector('.pm-body').scrollTop = 0;
        this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'auto' });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.restore(false);
      }
    });
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-toolbar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rhodecover-mobile-toolbar')) {
  customElements.define('rhodecover-mobile-toolbar', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.frame = null;
      this.schedule = () => {
        if (this.frame !== null) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      };
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-action]');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
        const action = link.dataset.action;
        if (action === 'shop') {
          const menu = document.querySelector('premium-product-menu');
          if (menu && typeof menu.open === 'function') {
            event.preventDefault();
            menu.open(event.detail === 0);
            this.returnFocus(menu.querySelector('dialog'), link);
            this.schedule();
          }
        }
        if (action === 'search') {
          const dialog = this.querySelector('.mt-search-dialog');
          if (dialog && typeof dialog.showModal === 'function') {
            event.preventDefault();
            if (!dialog.open) {
              this.searchOverflow = document.body.style.overflow;
              this.searchLocked = true;
              dialog.showModal();
              document.body.style.overflow = 'hidden';
            }
            dialog.querySelector('input[type="search"]').focus();
            this.schedule();
          }
        }
        if (action === 'bag') {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') {
            event.preventDefault();drawer.open(link);this.returnFocus(drawer,link);this.schedule();
          }
        }
      }, options);
      const searchDialog = this.querySelector('.mt-search-dialog');
      this.querySelector('.mt-search-close').addEventListener('click', () => searchDialog.close(), options);
      searchDialog.addEventListener('close', () => {
        this.unlockSearch();
        this.removeAttribute('data-covered');
        this.querySelector('[data-action="search"]').focus({preventScroll:true});
        this.schedule();
      }, options);
      searchDialog.addEventListener('click', event => {
        if (event.target !== searchDialog) return;
        const r = searchDialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) searchDialog.close();
      }, options);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.schedule();
      });
      this.observer.observe(document.body,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['open','class','aria-hidden']});
      document.addEventListener('focusin',this.schedule,options);
      document.addEventListener('focusout',this.schedule,options);
      window.addEventListener('pageshow',this.schedule,options);
      window.addEventListener('resize',this.schedule,options);
      if (window.visualViewport) window.visualViewport.addEventListener('resize',this.schedule,options);
      this.sync();
    }
    returnFocus(surface, link) {
      this.focusObserver?.disconnect();
      if (!surface) return;
      this.focusObserver = new MutationObserver(() => {
        const isOpen = surface.matches('dialog[open],details[open],cart-drawer.active');
        if (!isOpen) {
          this.focusObserver.disconnect();
          requestAnimationFrame(() => { this.sync(); if (link.isConnected && !this.hasAttribute('data-covered')) link.focus({preventScroll:true}); });
        }
      });
      this.focusObserver.observe(surface,{attributes:true,attributeFilter:['open','class']});
    }
    sync() {
      const focused = document.activeElement;
      const typing = focused && (focused.matches('input:not([type=checkbox]):not([type=radio]):not([type=submit]):not([type=button]),textarea') || focused.isContentEditable);
      const overlay = document.querySelector('dialog[open],details-modal details[open],cart-drawer.active,cart-notification.active,header-drawer details[open]');
      const covered = !!(typing || overlay);
      if (this.hasAttribute('data-covered') !== covered) this.toggleAttribute('data-covered',covered);
      const bubble = document.querySelector('#cart-icon-bubble');
      if (bubble) {
        const countBubble = bubble.querySelector('.cart-count-bubble');
        const countText = countBubble?.querySelector('[aria-hidden="true"]')?.textContent
          || countBubble?.querySelector('.visually-hidden')?.textContent || '';
        const number = countText.match(/\d+/);
        const count = countBubble ? (number ? Number(number[0]) : Number(this.dataset.cartCount)) : 0;
        if (Number.isFinite(count)) this.updateCount(count);
      }
    }
    updateCount(count) {
      const badge = this.querySelector('.mt-count');
      const label = this.querySelector('.mt-count-label');
      const text = count > 99 ? '99+' : String(count);
      if (badge.textContent !== text) badge.textContent = text;
      if (badge.hidden !== (count === 0)) badge.hidden = count === 0;
      const accessible = count + (count === 1 ? ' item' : ' items');
      if (label.textContent !== accessible) label.textContent = accessible;
      this.dataset.cartCount = String(count);
    }
    unlockSearch() {
      if (!this.searchLocked) return;
      document.body.style.overflow = this.searchOverflow;
      this.searchLocked = false;
    }
    disconnectedCallback() {
      this.unlockSearch();
      this.controller?.abort();this.observer?.disconnect();this.focusObserver?.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
